// ---------------------------------------------------------------------------
// Section 3: Size — W, H, Min-W, Max-W, Min-H, Max-H
// ---------------------------------------------------------------------------

import { InspectorSection } from '@/components/inspector'
import { CompactTextField, extractClassValue, replaceOrAddClass } from '../fields'
import type { CogoElement } from '@/features/page-editor/store/types'

export function SizeSection({
  element,
  updateClass,
}: {
  element: CogoElement
  updateClass: (transform: (cls: string) => string) => void
}) {
  const cls = element.className ?? ''

  return (
    <InspectorSection title="Size">
      {/* 2-column grid: Width column | Height column */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
        {/* Column headers */}
        <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider">Width</span>
        <span className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider">Height</span>

        {/* W / H */}
        <CompactTextField
          value={extractClassValue(cls, 'w-')}
          onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'w-', val ? `w-${val}` : ''))}
          placeholder="full, 64"
        />
        <CompactTextField
          value={extractClassValue(cls, 'h-')}
          onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'h-', val ? `h-${val}` : ''))}
          placeholder="48, auto"
        />

        {/* Min */}
        <div className="flex items-center gap-1">
          <span className="text-muted-foreground text-[10px] shrink-0">Min</span>
          <CompactTextField
            value={extractClassValue(cls, 'min-w-')}
            onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'min-w-', val ? `min-w-${val}` : ''))}
            placeholder="0"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-muted-foreground text-[10px] shrink-0">Min</span>
          <CompactTextField
            value={extractClassValue(cls, 'min-h-')}
            onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'min-h-', val ? `min-h-${val}` : ''))}
            placeholder="0"
          />
        </div>

        {/* Max */}
        <div className="flex items-center gap-1">
          <span className="text-muted-foreground text-[10px] shrink-0">Max</span>
          <CompactTextField
            value={element.maxWidth ?? extractClassValue(cls, 'max-w-')}
            onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'max-w-', val ? `max-w-${val}` : ''))}
            placeholder="lg"
          />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-muted-foreground text-[10px] shrink-0">Max</span>
          <CompactTextField
            value={extractClassValue(cls, 'max-h-')}
            onChange={(val) => updateClass((c) => replaceOrAddClass(c, 'max-h-', val ? `max-h-${val}` : ''))}
            placeholder="screen"
          />
        </div>
      </div>
    </InspectorSection>
  )
}
